@file:Suppress("MagicNumber", "EmptyCatchBlock", "ComplexCondition", "EmptyElseBlock", "ReturnCount")

package top.wcpe.allincore.ui.runtime.ir.eval

import top.wcpe.allincore.ui.runtime.ir.DslRuntimeError
import top.wcpe.allincore.ui.runtime.ir.DslValueUtils
import kotlin.jvm.JvmStatic

/** 二元运算分派器（C8 拆分自 ExprEvaluator）。 */
internal object BinaryOpEvaluator {

    @JvmStatic fun applyBinary(op: String, l: Any?, r: Any?): Any = when (op) {
        "+" -> plus(l, r)
        "-", "*", "/", "%" -> arithmetic(op, l, r)
        "==" -> DslValueUtils.equalsValue(l, r)
        "!=" -> !DslValueUtils.equalsValue(l, r)
        "<", "<=", ">", ">=" -> compare(op, l, r)
        else -> throw DslRuntimeError("不支持的二元运算符: $op")
    }

    private fun plus(l: Any?, r: Any?): Any {
        if (l is String || r is String) return DslValueUtils.stringify(l) + DslValueUtils.stringify(r)
        if (l is Number && r is Number) return l.toDouble() + r.toDouble()
        throw DslRuntimeError("不支持的 + 操作数: ${DslValueUtils.classOf(l)} , ${DslValueUtils.classOf(r)}")
    }

    private fun arithmetic(op: String, l: Any?, r: Any?): Any {
        val lv = tryAutoColorToNumber(l) ?: l
        val rv = tryAutoColorToNumber(r) ?: r
        if (lv !is Number || rv !is Number) {
            throw DslRuntimeError("算术 $op 要求两侧均为数值，实际: ${DslValueUtils.classOf(lv)} , ${DslValueUtils.classOf(rv)}")
        }
        return applyArithmeticOp(op, lv.toDouble(), rv.toDouble())
    }

    private fun applyArithmeticOp(op: String, ld: Double, rd: Double): Any = when (op) {
        "-" -> ld - rd
        "*" -> ld * rd
        "/" -> {
            if (rd == 0.0) throw DslRuntimeError("除以零")
            ld / rd
        }
        "%" -> {
            if (rd == 0.0) throw DslRuntimeError("对零取模")
            ld % rd
        }
        else -> throw AssertionError("不可达：$op")
    }

    private fun tryAutoColorToNumber(v: Any?): Any? {
        if (v is String && v.startsWith("#")) {
            try {
                val hex = v.substring(1)
                if (hex.length == 6) return 0xFF000000.toInt() or hex.toInt(radix = 16)
                if (hex.length == 8) return hex.toLong(radix = 16).toInt()
            } catch (_: NumberFormatException) { }
        }
        return v
    }

    private fun compare(op: String, l: Any?, r: Any?): Boolean {
        if (l !is Number || r !is Number) {
            throw DslRuntimeError("比较 $op 要求两侧均为数值，实际: ${DslValueUtils.classOf(l)} , ${DslValueUtils.classOf(r)}")
        }
        val ld = l.toDouble()
        val rd = r.toDouble()
        return when (op) {
            "<" -> ld < rd
            "<=" -> ld <= rd
            ">" -> ld > rd
            ">=" -> ld >= rd
            else -> throw AssertionError("不可达：$op")
        }
    }
}
